import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { LoginDataSliceState } from '@paragon/login-tools';

export const useLibrarySelector: TypedUseSelectorHook<LoginDataSliceState> = useSelector;
